/**
 * JS functions for public pages
 */

// !Idea Form
springSpace.la.ideaform = function (config) {
    this.$form = jQuery('#ideaform');
    this.errormsg = config.errormsg;

    var that = this;
    this.$form.on('submit', function (e) {
        e.preventDefault();

        that.$form.find('label .error-message').remove();
        that.$form.find('.form-group').removeClass('has-error');
        that.$form.find('.form-control').attr('aria-invalid', false);
        var error_msg = '';

        var $titlefield = that.$form.find('input[name=title]');
        if ($titlefield.val() == '') {
            that.markError($titlefield, that.errormsg.reqfields);
        }
        var $bodyfield = that.$form.find('textarea[name=body]');
        if ($bodyfield.val() == '') {
            that.markError($bodyfield, that.errormsg.reqfields);
        }

        var $emailfield = that.$form.find('input[name=email]');
        var emailask = $emailfield.val().trim();

        if (!emailask.match(springSpace.regex.email)) {
            that.markError($emailfield, that.errormsg.emailaddress);
        }

        if (that.$form.find('.has-error').length > 0) {
            errorAlert();
            that.$form.find('*[aria-invalid=true]:first').focus();
            return false;
        }

        jQuery.ajax({
            url: that.$form.attr('action'),
            method: that.$form.attr('method'),
            data: that.$form.serialize(),
        }).done(function () {
            successAlert();
        }).fail(
            jqAjaxFailCallback,
        ).always(function () {
            closeModal();
        });
    });

    // set an error (msg) for the input (id)
    this.markError = function ($input, msg) {
        var msg_div = jQuery('<div class="error-message"></div>').html(msg);
        $input.attr('aria-invalid', true).parent().addClass('has-error').find('label').append(msg_div);
    };
}; // end ideaform
// ========================================================
// !Idea Comment Form
springSpace.la.ideacommentform = function (config) {
    this.$form = jQuery('#ideacommentform');
    this.errormsg = config.errormsg;

    var that = this;
    this.$form.on('submit', function (e) {
        e.preventDefault();

        that.$form.find('label .error-message').remove();
        that.$form.find('.form-group').removeClass('has-error');
        that.$form.find('.form-control').attr('aria-invalid', false);
        var error_msg = '';

        var $emailfield = that.$form.find('input[name=email]');
        var emailask = jQuery.trim($emailfield.val());
        if (!emailask.match(springSpace.regex.email)) {
            that.markError($emailfield, that.errormsg.emailaddress);
        }

        if (that.$form.find('.has-error').length > 0) {
            errorAlert();
            that.$form.find('*[aria-invalid=true]:first').focus();
            return false;
        }

        jQuery.ajax({
            url: that.$form.attr('action'),
            data: that.$form.serialize(),
            method: that.$form.attr('method'),
        }).done(function (d) {
            successAlert();
            if (d.upvote == 1) {
                var $votediv = jQuery('#product_idea_' + d.idea_id + ' .s-la-idea-upvotes');
                var vote = parseInt($votediv.text(), 10) + 1;
                $votediv.text(vote);
            } else if (d.downvote == 1) {
                var $votediv = jQuery('#product_idea_' + d.idea_id + ' .s-la-idea-downvotes');
                var vote = parseInt($votediv.text(), 10) + 1;
                $votediv.text(vote);
            }
            closeModal();
        }).fail(jqAjaxFailCallback);
    });

    // set an error (msg) for the input (id)
    this.markError = function ($input, msg) {
        var msg_div = jQuery('<div class="error-message"></div>').html(msg);
        $input.attr('aria-invalid', true).parent().addClass('has-error').find('label').append(msg_div);
    };

    this.$form.find('.btn-cancel').on('click', function (e) {
        closeModal();
    });
}; // end ideacommentform

////////////////////////////////
// Public FAQ page

/**
 * Records a hit/view for an FAQ.
 * @param {Number} faqId FAQ id.
 * @param {Number} instId Site instid.
 * @param {Number} hitType Type of view/share (ses FAQStatConstants).
 */
const faqHit = function (faqId, instId, hitType) {
    // Fire and forget, we don't need to tell the patron if the stat failed.
    jQuery.ajax({
        method: 'POST',
        url: `/faq/${faqId}/view`,
        data: {
            type: hitType,
        },
        dataType: 'json',
    });
};

/**
 * Vote on an FAQ.
 * @param {Number} faqId FAQ id to vote on.
 * @param {Number} v The yes (1) or no (0).
 */
const faqVote = function (faqId, v) {
    if (!faqId) {
        return;
    }

    jQuery.ajax({
        method: 'POST',
        url: `/faq/${faqId}/vote`,
        data: {
            v: v,
        },
        dataType: 'json',
    })
        .done((d) => {
            if (!d.success) {
                return;
            }
            let counter = null;
            if (d.vote === 1) {
                counter = jQuery('#s-la-vote-yes-ct');
                counter.html(parseInt(counter.text()) + 1);
                jQuery('#s-la-vote-yes').addClass('voted');
            } else if (d.vote === 0) {
                counter = jQuery('#s-la-vote-no-ct');
                counter.html(parseInt(counter.text()) + 1);
                jQuery('s-la-vote-no').addClass('voted');
            }
            jQuery('#s-la-vote button').attr('disabled', 'true');
        })
        .fail(jqAjaxFailCallback);
};

/**
 * Get related FAQs.
 * @param {Number} faqid Current faqid.
 */
const loadRelatedFAQs = function (faqid) {
    const relatedFAQList = document.getElementById('s-la-faq-relatedfaqs');
    if (!relatedFAQList) {
        return;
    }
    $.ajax({
        method: 'GET',
        url: `/faq/${faqid}/related`,
        dataType: 'json',
    })
        .done((data) => {
            if (data.content) {
                relatedFAQList.innerHTML = data.content;
            }
        })
        .fail(() => {
            // Ignore
        });
};

/**
 * FAQ Page
 * Zindex fix for videos in iframes (is this still necessary?)
 */
const fixMediaZindex = function () {
    document.querySelectorAll('.s-la-faq-media-wrapper iframe').forEach((el) => {
        const src = el.getAttribute('src');
        const wmode = 'wmode=transparent';
        if (src.indexOf('?') !== -1) {
            el.setAttribute('src', `${src}&${wmode}`);
        } else {
            el.setAttribute('src', `${src}?${wmode}`);
        }
    });
};

/**
 * FAQ Page vote button handlers.
 * @param {Number} faqid Current faqid.
 */
const faqVoteButtons = function (faqid) {
    document.querySelectorAll('#s-la-vote-no, #s-la-vote-yes').forEach((el) => {
        el.addEventListener('click', (ev) => {
            ev.preventDefault();
            const btn = ev.currentTarget;
            const warn = btn.dataset.warn;
            if (warn !== '') {
                alert(warn);
                return;
            }
            const type = parseInt(btn.dataset.vote, 10);
            faqVote(faqid, type);
        });
    });
};

/**
 * Setup handlers/actions on FAQ Answer page.
 * @param {Number} faqid Current faq id
 * @param {Number} instId Current site instid
 * @param {Boolean} isPreview Is user previewing FAQ.
 * @param {String} redirectUrl the URL to redirect this page to, if any
 */
const setUpAnswerPage = function (faqid, instId, isPreview, redirectUrl) {
    if (faqid <= 0) {
        return;
    }
    if (!isPreview) {
        // FAQStatConstants::VIEW_TYPE_FAQPAGE
        faqHit(faqid, instId, 1);
    }
    if (redirectUrl && redirectUrl !== document.referrer) {
        window.location.href = redirectUrl;
    }
    loadRelatedFAQs(faqid);
    fixMediaZindex();
    faqVoteButtons(faqid);
};

/**
 * Actions for all public pages.
 */
const setUpPublicPage = function () {
    // Clear any libauth token from the url bar so reloads don't re-use it.
    const url = new URL(window.location);
    if (url.searchParams.has('token')) {
        url.searchParams.delete('token');
        history.replaceState({}, '', url.toString());
    }

    // Event delegation for clicks.
    document.body.addEventListener('click', (ev) => {
        const tags = ['A', 'I', 'SPAN', 'B', 'STRONG'];
        const tag = ev.target.tagName;
        // links and possible children of links
        if (tags.indexOf(tag) === -1) {
            return;
        }
        const link = ev.target.closest('a');
        if (!link) {
            return;
        }
        let modal = null;
        if (link.classList.contains('imagepreviewlink')) {
            // image previews in FAQs
            ev.preventDefault();
            modal = new springSpace.sui.modal({ url: link.getAttribute('href'), size: 'large' });
        } else if (link.classList.contains('modallink')) {
            ev.preventDefault();
            modal = new springSpace.sui.modal({ url: link.getAttribute('href') });
        }
    });
};

/**
 * Calculates document height.
 * Used by Question Form in search page modal to make sure the iframe it's embedded in is big enough.
 * When we refactor search JS we should be able to put the form in the page without the frame.
 * @returns {Number}
 */
const getDocHeight = function () {
    return Math.max(
        Math.max(document.body.scrollHeight, document.documentElement.scrollHeight),
        Math.max(document.body.offsetHeight, document.documentElement.offsetHeight),
        Math.max(document.body.clientHeight, document.documentElement.clientHeight),
    );
};
